var _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierLedger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "blockchain_1_",
    d: "M30,30.36h-6c-0.199,0-0.36-0.161-0.36-0.36v-2.64h-4.28V30c0,0.199-0.161,0.36-0.36,0.36h-6 c-0.199,0-0.36-0.161-0.36-0.36v-2.64H8.36V30c0,0.199-0.161,0.36-0.36,0.36H2c-0.199,0-0.36-0.161-0.36-0.36v-6 c0-0.199,0.161-0.36,0.36-0.36h2.64v-4.28H2c-0.199,0-0.36-0.161-0.36-0.36v-6c0-0.199,0.161-0.36,0.36-0.36h2.64V8.36H2 C1.801,8.36,1.64,8.199,1.64,8V2c0-0.199,0.161-0.36,0.36-0.36h6c0.199,0,0.36,0.161,0.36,0.36v2.64h4.28V2 c0-0.199,0.161-0.36,0.36-0.36h6c0.199,0,0.36,0.161,0.36,0.36v2.64h4.279V2c0-0.199,0.161-0.36,0.36-0.36h6 c0.199,0,0.36,0.161,0.36,0.36v6c0,0.199-0.161,0.36-0.36,0.36h-2.64v4.28H30c0.199,0,0.36,0.161,0.36,0.36v6 c0,0.199-0.161,0.36-0.36,0.36h-2.64v4.279H30c0.199,0,0.36,0.161,0.36,0.36v6C30.36,30.199,30.199,30.36,30,30.36z M24.36,29.64 h5.279v-5.28H24.36V29.64z M13.36,29.64h5.28v-5.28h-5.28C13.36,24.36,13.36,29.64,13.36,29.64z M2.36,29.64h5.28v-5.28H2.36V29.64z M19.36,26.64h4.279V24c0-0.199,0.161-0.36,0.36-0.36h2.64v-4.28H24c-0.199,0-0.36-0.161-0.36-0.36v-2.64h-4.28V19 c0,0.199-0.161,0.36-0.36,0.36h-2.64v4.279H19c0.199,0,0.36,0.161,0.36,0.36V26.64z M8.36,26.64h4.28V24 c0-0.199,0.161-0.36,0.36-0.36h2.64v-4.28H13c-0.199,0-0.36-0.161-0.36-0.36v-2.64H8.36V19c0,0.199-0.161,0.36-0.36,0.36H5.36v4.279 H8c0.199,0,0.36,0.161,0.36,0.36V26.64z M27,18.64h2.64v-5.28h-5.28v5.28H27z M16,18.64h2.64v-5.28h-5.28v5.28H16z M5,18.64h2.64 v-5.28H2.36v5.28H5z M19.36,15.64h4.279V13c0-0.199,0.161-0.36,0.36-0.36h2.64V8.36H24c-0.199,0-0.36-0.161-0.36-0.36V5.36h-4.28V8 c0,0.199-0.161,0.36-0.36,0.36h-2.64v4.28H19c0.199,0,0.36,0.161,0.36,0.36V15.64z M8.36,15.64h4.28V13 c0-0.199,0.161-0.36,0.36-0.36h2.64V8.36H13c-0.199,0-0.36-0.161-0.36-0.36V5.36H8.36V8c0,0.199-0.161,0.36-0.36,0.36H5.36v4.28H8 c0.199,0,0.36,0.161,0.36,0.36V15.64z M27,7.64h2.64V2.36h-5.28v5.28C24.36,7.64,27,7.64,27,7.64z M16,7.64h2.64V2.36h-5.28v5.28 C13.36,7.64,16,7.64,16,7.64z M5,7.64h2.64V2.36H2.36v5.28C2.36,7.64,5,7.64,5,7.64z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierLedger);
export default __webpack_public_path__ + "static/media/supplier-ledger.83ecaff40441352d89616c92ad979010.svg";
export { ForwardRef as ReactComponent };